import classNames from 'classnames';
import styles from './LinkButton.module.scss';
import { UI_Link, UI_LinkProps } from 'ui/components/1-atoms/Action/Link/Link';

export interface UI_LinkButtonProps extends Omit<UI_LinkProps, 'style'> {
	children: React.ReactNode;
	state?: 'inactive';
	style?: 'primary' | 'secondary' | 'inactive' | 'sm';
	inheritsColor?: boolean;
	className?: string;
	colorOverride?: string;
	colorOverrideTextColor?: string;
}

export const UI_LinkButton: React.FC<UI_LinkButtonProps> = ({
	children,
	style,
	inheritsColor,
	className,
	state,
	colorOverride,
	colorOverrideTextColor,
	...props
}) => {
	const cssStyle: React.CSSProperties | undefined = colorOverride
		? style === 'primary'
			? { backgroundColor: colorOverride, borderColor: colorOverride, color: colorOverrideTextColor ?? 'var(--color-white)' }
			: { color: colorOverride, borderColor: colorOverride }
		: undefined;

	return (
		<UI_Link
			cssStyle={cssStyle}
			className={classNames(
				styles.LinkButton,
				styles[`LinkButton___${style}`],
				styles[`LinkButton___${state}`],
				{ [styles.LinkButton___inheritsColor]: inheritsColor },
				className,
			)}
			target={props.target}
			href={props.href}
			{...props}
		>
			<div className={styles.LinkButton_textContainer}>
				<span className={styles.LinkButton_text}>{children}</span>
				<span className={classNames(styles.LinkButton_text, styles.LinkButton_text___animationText, className)}>{children}</span>
			</div>
		</UI_Link>
	);
};
